import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoSubmit: { type: Boolean, default: false },
    autoSubmitTimeout: { type: Number, default: 60000 },
  }

  static targets = ["range", "startDate", "endDate"]

  connect() {
    if (this.autoSubmitValue) {
      this.startAutoSubmit()
    }
  }

  disconnect() {
    if (this.submitTimer) {
      this.stopAutoSubmit()
    }
  }

  startAutoSubmit() {
    this.submitTimer = setTimeout(() => {
      this.submit()
    }, this.autoSubmitTimeoutValue)
  }

  stopAutoSubmit() {
    clearTimeout(this.submitTimer)
  }

  submit() {
    if (this.rangeTarget.textContent != "Custom") {
      this.setDatesFromRange(this.rangeTarget.textContent)
    }

    this.element.requestSubmit()
  }

  rangeChange(event) {
    this.setDatesFromRange(event.params.range)
    this.rangeTarget.textContent = event.target.textContent
  }

  setDatesFromRange(range) {
    const { start_date: rangeStartDate, end_date: rangeEndDate } =
      this.defaultDateRanges()[range]

    this.startDateTarget.value = rangeStartDate
    this.endDateTarget.value = rangeEndDate
  }

  dateChange() {
    const startDate = this.startDateTarget.value
    const endDate = this.endDateTarget.value

    if (startDate != "" && endDate != "") {
      const rangeText = Object.keys(this.defaultDateRanges()).find((range) => {
        const { start_date: rangeStartDate, end_date: rangeEndDate } =
          this.defaultDateRanges()[range]
        return rangeStartDate == startDate && rangeEndDate == endDate
      })

      this.rangeTarget.textContent = rangeText || "Custom"
    } else {
      this.rangeTarget.textContent = "Custom"
    }
  }

  defaultDateRanges() {
    const today = new Date()
    const daysAgo = (days) =>
      new Date(new Date().setDate(today.getDate() - days))
    const toDateString = (date) => date.toISOString().split("T")[0]

    return {
      Today: { start_date: toDateString(today), end_date: toDateString(today) },
      "Last Week": {
        start_date: toDateString(daysAgo(7)),
        end_date: toDateString(today),
      },
      "Last Month": {
        start_date: toDateString(daysAgo(30)),
        end_date: toDateString(today),
      },
      "Last Quarter": {
        start_date: toDateString(daysAgo(90)),
        end_date: toDateString(today),
      },
      "Last Year": {
        start_date: toDateString(daysAgo(365)),
        end_date: toDateString(today),
      },
    }
  }
}
